
    var riot = require('riot')
    //src: shared/tags/app-notification.html
riot.tag2('app-notification',
  '<div ref="main" class="app-notification hidden {\'app-notification--plover\': this.isPlover}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}"> <i if="{!this.isPlover}" ref="icon" class="material-icons link-icon">{icon || \'link\'}</i> <svg class="plover-icon" if="{this.isPlover}"> <use ref="icon" xlink:href="#map-icon"></use> </svg> <p ref="text"> Link copied to clipboard </p> <button if="{this.isPlover}" ref="undo" onclick="{undo}" class="mrgn-l-8 Button Button--Small Button--Outlined Button--Dark"> <span class="Button__Label">Undo</span> </button> <button if="{this.isPlover}" ref="view" onclick="{view}" class="mrgn-l-8 Button Button--Small Button--Outlined Button--Dark"> <span class="Button__Label">View</span> </button> <svg ref="closeIcon" width="18" height="18" style="cursor: pointer;" class="plover-icon hidden" onclick="{hide}" if="{this.isPlover}"> <use xlink:href="#close-icon"></use> </svg> <p ref="upgradeText" class="hidden upgrade-text"> Attach files up to {SUBSCRIBER_FILE_MAX_SIZE / 1000000}MB by <span onclick="{upgrade}" class="upsell-link">upgrading to Plectica Pro</span> </p> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this; //style in app-banners.scss

var _constants = require('lib/constants');

this.SUBSCRIBER_FILE_MAX_SIZE = _constants.SUBSCRIBER_FILE_MAX_SIZE;
this.canvas = this.opts.canvas || this.opts.app;
this.canvas.notificationTag = this;
if (this.opts.app) this.isPlover = true;
var mouseOutTimeout = this.isPlover ? _constants.PLOVER_NOTIFICATION_TAG_MOUSEOUT_TIMEOUT : _constants.NOTIFICATION_TAG_MOUSEOUT_TIMEOUT;
var timeout = this.isPlover ? _constants.PLOVER_NOTIFICATION_TAG_TIMEOUT : _constants.NOTIFICATION_TAG_TIMEOUT;

this.show = function (_ref) {
  var message = _ref.message,
      isWarning = _ref.isWarning,
      showUpgrade = _ref.showUpgrade,
      undoCallback = _ref.undoCallback,
      viewCallback = _ref.viewCallback,
      icon = _ref.icon;

  var $main = $(_this.refs.main);
  $main.removeClass('warning');
  _this.refs.upgradeText.classList.add('hidden');
  _this.refs.text.innerText = message;
  _this.undoCallback = undoCallback;
  _this.viewCallback = viewCallback;
  if (_this.isPlover) {
    if (icon) {
      _this.refs.icon.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', icon);
    } else {
      _this.refs.icon.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', 'map-icon');
    }
  } else {
    if (icon) {
      _this.refs.icon.innerText = icon;
    } else {
      _this.refs.icon.innerText = 'link';
    }
  }
  if (isWarning) $main.addClass('warning');
  $main.removeClass('hidden');
  $main.removeClass('hidden-fade-out');

  if (_this.isPlover) {
    if (undoCallback) {
      _this.refs.undo.classList.remove('hidden');
    } else {
      _this.refs.undo.classList.add('hidden');
    }
    if (viewCallback) {
      _this.refs.view.classList.remove('hidden');
    } else {
      _this.refs.view.classList.add('hidden');
    }
  }
  if (showUpgrade) {
    _this.refs.upgradeText.classList.remove('hidden');
  }
  _this.canvas.notificationBannerTimeout = setTimeout(_this.hide, timeout);
};

this.hide = function () {
  $(_this.refs.main).addClass('hidden-fade-out');
};

this.upgrade = function () {
  _this.canvas.showPaymentModal();
};

this.handleMouseEnter = function () {
  var $main = $(_this.refs.main);
  $main.removeClass('hidden');
  $main.removeClass('hidden-fade-out');
  clearTimeout(_this.canvas.notificationBannerTimeout);
};

this.handleMouseLeave = function () {
  _this.canvas.notificationBannerTimeout = setTimeout(_this.hide, mouseOutTimeout);
};

this.undo = function () {
  if (_this.undoCallback) {
    _this.undoCallback();
    _this.hide();
  }
};

this.view = function () {
  if (_this.viewCallback) {
    _this.viewCallback();
    _this.hide();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('app-notification')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./shared/tags/app-notification.html
// module id = 805
// module chunks = 0